import { combineReducers, configureStore } from '@reduxjs/toolkit'
import type { PreloadedState } from '@reduxjs/toolkit'

/* Import the services */
import { InstitutionsApi } from 'Services/institution'
import { CTAButtonsApi } from 'Services/CTAButtons'
import { AnalyticsApi } from 'Services/analytics'
import { AiApi } from 'Services/ai'

/* Import the app redux Reducer slices */
import LocationReducer from '../slices/LocationSlice'
import LanguageReducer from '../slices/LanguageSlice'
import AppModeReducer from '../slices/AppModeSlice'
import AiReducer from '../slices/AiSlice'
import CifReducer from '../slices/CifSlice'

/* Define the services to be used by the app */
const services = [InstitutionsApi, CTAButtonsApi, AnalyticsApi, AiApi]

/* Define the App reducers */
const appReducers = {
  location: LocationReducer,
  language: LanguageReducer,
  appMode: AppModeReducer,
  cif: CifReducer,
  ai: AiReducer,
}

const serviceReducers = services.reduce((acc, service) => {
  acc[service.reducerPath] = service.reducer
  return acc
}, {})

const serviceMiddleware = services.reduce((acc, service) => {
  acc.push(service.middleware)
  return acc
}, [])

const rootReducer = combineReducers({
  ...serviceReducers,
  ...appReducers,
})

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      // adding the api middleware enables caching, invalidation, polling and other features of `rtk-query`
      [...getDefaultMiddleware(), ...serviceMiddleware],
    preloadedState,
  })

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
